'use client';

// framer-motion needs a client boundary for the App Router routes that render this.
// The directive is inert in the Pages Router, so the unmigrated routes importing it
// are unaffected (#489, FR-012).
import { PropsWithChildren } from 'react';

import { motion } from 'framer-motion';

import { useFadeInTransition } from 'hooks/browser/transitions';

const Page = ({ children = [] }: PropsWithChildren<{}>) => {
  const { container, item } = useFadeInTransition();

  return (
    <>
      <motion.div
        className="page-root"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {(Array.isArray(children) ? children : [children]).map(
          (child, index) => (
            <motion.section key={index} variants={item}>
              {child}
            </motion.section>
          ),
        )}
      </motion.div>
    </>
  );
};

export default Page;
